import React from 'react';
import {Col, Button} from 'reactstrap';
import {Link} from 'react-router-dom';
import {FormattedMessage, useIntl} from 'react-intl';
import ReactMarkdown from 'react-markdown';
import {confirmAlert} from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import ConfirmBorrar from './confirmBorrar';
import {deleteArticle} from '../api/articles';
import {connect} from 'react-redux';
import {fetchArticles, removeArticles} from '../reducer/article-reducer';
import {publishArticle, unPublishArticle} from '../api/articles';
interface tag {
  description: string;
}
interface propiedades {
  articulo: {
    title: string;
    brief: string;
    id: string;
    tags: tag[];
    publishedAt: string | null;
  };
  token: string;
  fetchArticles: any;
  removeArticles: () => void;
}

interface configObject {
  user: {
    token: string;
  };
}

const ItemListaArticulo = (props: propiedades) => {
  const {articulo, token, fetchArticles, removeArticles} = props;
  const intl = useIntl();

  const confirmarBorrar = () => {
    confirmAlert({
      customUI: ({onClose}) => {
        return <ConfirmBorrar onClose={onClose} borrar={borrar} intl={intl} />;
      },
    });
  };

  const borrar = () => {
    deleteArticle(articulo.id, token).then((res) => {
      removeArticles();
      fetchArticles(token);
    });
  };

  const handlePublishUnpublish = async () => {
    let res: string | {data: {id: string}};
    if (articulo?.publishedAt) {
      res = await unPublishArticle(articulo.id!, token);
    } else {
      res = await publishArticle(articulo.id!, token);
    }
    if (typeof res === 'object' && res.data?.id === articulo.id) {
      removeArticles();
      fetchArticles(token);
    }
  };

  return (
    <Col className="border mt-2 mb-2 p-2 item-articulo">
      <h2>{articulo.title}</h2>
      <ReactMarkdown>{articulo.brief}</ReactMarkdown>
      <div className="d-flex justify-content-between">
        <div className="tag-wrapper">
          {articulo.tags.map((tag: tag, index: number) => {
            return (
              <span className="badge background-primary me-2 p-2" key={index}>
                {tag.description}
              </span>
            );
          })}
        </div>
        <div className="button-wrapper">
          <Button
            tag={Link}
            className="me-2 background-primary border-0"
            onClick={handlePublishUnpublish}
          >
            {articulo.publishedAt ? 'despublicar' : 'publicar'}
          </Button>
          <Button
            tag={Link}
            to={`/admin/articulo/${articulo.id}`}
            className="me-2 background-primary border-0"
          >
            <FormattedMessage id="view_more" defaultMessage="view_more" />
          </Button>
          <Button tag={Link} color="danger" onClick={confirmarBorrar}>
            <FormattedMessage id="delete" defaultMessage="delete" />
          </Button>
        </div>
      </div>
    </Col>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    token: state.user.token,
  };
};
export default connect(mapStateToProps, {fetchArticles, removeArticles})(
  ItemListaArticulo,
);
